import { Div, Ref, Span } from '@tblabs/truffle';
import { ConnectionStatusEvent } from '../../../Services/ConnectionStatusEvent';
import { ICamera } from '../../../Services/Camera/ICamera';
import { BarChart } from "./BarChart";
import { BlobPicture } from "../../../Models/BlobPicture";
import { IServer } from '../../../Services/IServer';


export class SignalStrengthIndicator extends Div
{
    constructor(_server: IServer, _camera: ICamera)
    {
        super();
        this.DisplayInlineBlock().PositionRelative();

        const noSignal = new Span("×").FontSize(26).Color("#fff").PositionAbsolute().Top(-10).Left(5)
            .Hide()

        const val = new Ref<number>(0);
        let lastPictureMoment;

        _camera.OnNewPicture.Subscribe((picture: BlobPicture) =>
        {
            noSignal.Hide();

            let now = new Date();

            let diff = +now - +lastPictureMoment;

            if (diff < 3000)
                val.value = 4;
            else if (diff < 6000)
                val.value = 3;
            else if (diff < 12000)
                val.value = 2;
            else
                val.value = 1;

            lastPictureMoment = now;
        });

        _server.OnConnectionChange.Subscribe((status: ConnectionStatusEvent) =>
        {
            if (status.IsNotConnected)
            {
                val.value = 0;
                noSignal.Show().Color("red");
            }
            else 
            {
                noSignal.Color("#fff");
            }
        });

        _camera.OnConnectionChange.Subscribe((connection: ConnectionStatusEvent) =>
        {
            if (connection.IsNotConnected)
            {
                val.value = 0;
                noSignal.Show();
            }
            else 
            {
                noSignal.Hide();
            }
        });

        this.Append(
            new BarChart(val),
            noSignal,
        );
    }
}
